import {
  DateUtilInstance,
  getNow,
  getNowAsDate,
} from '@zorro/shared/formatters';

function maxAllowedAdultBirthDate(
  targetDate: DateUtilInstance
): DateUtilInstance {
  return targetDate.startOf('day').subtract(18, 'years');
}

function minAllowedDependentBirthDate(
  targetDate: DateUtilInstance
): DateUtilInstance {
  return targetDate.startOf('day').subtract(26, 'years');
}

export function insuredMinDateOfBirth(
  isDependent: boolean,
  effectiveFromDate: DateUtilInstance | null | undefined
): Date | undefined {
  if (!isDependent || effectiveFromDate === undefined) {
    return undefined;
  }
  const targetDate = effectiveFromDate || getNow();
  return minAllowedDependentBirthDate(targetDate).toDate();
}

export function insuredMaxDateOfBirth(
  isDependent: boolean,
  effectiveFromDate: DateUtilInstance | null | undefined
): Date | undefined {
  if (isDependent) {
    return getNowAsDate();
  }

  const targetDate = effectiveFromDate || getNow();

  return maxAllowedAdultBirthDate(targetDate).toDate();
}
